import theme from "@src/styles/theme";

export default theme;
